module.exports = __webpack_public_path__ + "img/Vinje_Politikk_og_folkeopplysning.5840a98e.jpg";